import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { log } from '@24i/nxg-core-utils/src/logger';

export const DEFAULT_CACHE_TIME = 1000 * 60 * 10; // 10 minutes

export const clientQuery = new QueryClient({
    queryCache: new QueryCache({
        onError: (error) => {
            log(error);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error) => {
            log(error);
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_CACHE_TIME,
            cacheTime: DEFAULT_CACHE_TIME,
            refetchOnWindowFocus: false,
        },
    },
});
